import LoginPage from "./components";

export const loginPageService = ({ getConfig }: any) => {
    const showLoginPage = getConfig("one.box.login-page.show", true);

    if (!showLoginPage) {
        return [];
    }

    const logo: { src: string; description: string } = getConfig("one.box.logo", {
        src: "https://appdev.teamsystemdigital.com/images/ts-digital/prelogin/logo-digital.svg",
        description: "ts digital logo",
    });

    return [
        {
            target: "$ONE_AUTH_PUBLIC_VIEW",
            handler: {
                component: LoginPage,
                props: {
                    appName: "TeamSystem Digital",
                    cookiePolicyUrl: "cookiePolicyUrl",
                    logo: logo,
                    loginButtonLabel: "Accedi",
                    privacyPolicyurl: "https://tc.teamsystem.com/InformativaPrivacyTSDigital.pdf",
                },
            },
        },
    ];
};
